import Unauthorized from '@package/components/ErrorPages/Unauthorized/Unauthorized';

export default Unauthorized;
